import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/CustomerProfile\/Update/,
      messages: {
        400: 'errors.customerProfileUpdateFailed',
        404: 'errors.customerProfileUpdateFailed',
        500: 'errors.customerProfileUpdateFailed',
        success: {
          default: 'errors.customerProfileUpdateFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
